import CKEditorHelper from "base/CKEditorHelper";
import FieldEditor from "editor/FieldEditor";

class FieldEditorWysiwyg extends FieldEditor {
    create() {
        this.loading = true;
        CKEditorHelper.load().then(() => {
            FieldEditorWysiwyg.update_default_link_target();
            FieldEditorWysiwyg.add_body_offset_listener();

            this.loading = false;
            if (this.destroyed) {
                return;
            }

            const settings = this.settings;

            if (settings['noHtml']) {
                this.$originalElement = this.$element;

                let $editor = eotwJSXFactory('div', null, [this.$element.text()]);
                this.$element.html($editor);

                this.$element = $editor;
            }

            this.$element.attr("contenteditable", true).addClass("editing");

            const ckeditorOptions = {
                removePlugins: [],
                extraPlugins: [],
                forcePasteAsPlainText: true,
            };

            if (settings['allowedTags']) {
                settings['allowedElements'] = settings['allowedTags'];
            }
            if (settings['disablePlugins']) {
                settings['removePlugins'] = settings['disablePlugins'];
            }

            if (settings["noFormatting"] || settings["noHtml"]) {
                ckeditorOptions["formatTags"] = "";
                ckeditorOptions["enterMode"] = CKEDITOR.ENTER_BR;
                ckeditorOptions["allowedContent"] = "";
                ckeditorOptions["removePlugins"].push("clipboard,notification,toolbar,pastetext,image2,widget");
            } else if (settings["allowedElements"]) {
                ckeditorOptions["allowedContent"] = settings["allowedElements"];
            } else {
                ckeditorOptions["allowedContent"] = FieldEditorWysiwyg.DEFAULT_TAGS;
            }

            if (settings["singleParagraph"]) {
                ckeditorOptions["enterMode"] = CKEDITOR.ENTER_BR;
            }

            if (settings["noToolbar"]) {
                ckeditorOptions["removePlugins"].push("clipboard,notification,toolbar,pastetext");
            }

            if (settings["noImages"] === true) {
                ckeditorOptions["toolbar"] = "no-images";
            }
            if (settings["removePlugins"]) {
                if (Array.isArray(settings["removePlugins"])) {
                    ckeditorOptions["removePlugins"] = ckeditorOptions["removePlugins"].concat(settings["removePlugins"]);
                } else {
                    ckeditorOptions["removePlugins"].push(settings["removePlugins"]);
                }
            }
            if (settings["extraPlugins"]) {
                if (Array.isArray(settings["extraPlugins"])) {
                    ckeditorOptions["extraPlugins"] = ckeditorOptions["extraPlugins"].concat(settings["extraPlugins"]);
                } else {
                    ckeditorOptions["extraPlugins"].push(settings["extraPlugins"]);
                }
            }
            if (settings["baseFloatZIndex"]) {
                ckeditorOptions["baseFloatZIndex"] = settings["baseFloatZIndex"];
            }
            if (settings["maxLength"]) {
                ckeditorOptions.wordcount = {
                    showCharCount: true,
                    showWordCount: false,
                    showParagraphs: false,
                    maxCharCount: settings["maxLength"],
                };
            } else {
                ckeditorOptions["removePlugins"].push("wordcount");
            }
            ckeditorOptions["removePlugins"] = ckeditorOptions["removePlugins"].join(",").split(",").map((val) => val.trim()).join(",");
            ckeditorOptions["extraPlugins"] = ckeditorOptions["extraPlugins"].join(",").split(",").map((val) => val.trim()).join(",");
            if (settings['minHeight']) {
                ckeditorOptions.autoGrow_minHeight = settings['minHeight'];
                ckeditorOptions.resize_minHeight = settings['minHeight'];
            }

            if (this.settings.inline) {
                this.editor = CKEDITOR.inline(this.$element[0], ckeditorOptions);
            } else {
                this.editor = CKEDITOR.replace(this.$element[0], ckeditorOptions);
            }

            this.editor.on("change", () => this.emit("change", this.getValue()));

            setTimeout(() => this.emit("ckeditorInit", this.editor));

            if (this.value) {
                this.setValue(this.value);
            }
        });
    }

    destroy() {
        super.destroy();

        let value = this.getValue();
        if (this.editor) {
            this.editor.destroy();
        }
        this.editor = null;

        if (this.settings['noHtml']) {
            this.$element.remove();
            this.$originalElement.text(value);
        } else {
            this.$element.removeClass("editing").removeAttr("contenteditable").html(value);
        }
    }

    getValue() {
        if (this.loading || !this.editor) return this.value;

        let value = this.editor.getData().trim();

        if (this.settings["noHtml"]) {
            return (eotwJSXFactory('div', {unsafeHtml: value}))[0].innerText;
        }

        return value;
    }

    setValue(value) {
        if (this.loading) {
            this.value = value;
        } else {
            this.editor.setData(value);
        }
    }

    static add_body_offset_listener() {
        if (FieldEditorWysiwyg.body_offset_listener_added) {
            return;
        }
        FieldEditorWysiwyg.body_offset_listener_added = true;

        $(window).on("resize", () => {
            let $body = $("body");
            $body.css("--cke-body-top-offset", $body.css("margin-top"));
        });

        let $body = $("body");
        $body.css("--cke-body-top-offset", $body.css("margin-top"));
    }

    static update_default_link_target() {
        if (!window.CKEDITOR || FieldEditorWysiwyg.default_link_target_set) {
            return;
        }
        FieldEditorWysiwyg.default_link_target_set = true;
        window.CKEDITOR.on("dialogDefinition", function (ev) {
            if (ev.data.name !== "link") {
                return;
            }

            try {
                let informationTab = ev.data.definition.getContents("target");
                let targetField = informationTab.get("linkTargetType");

                const originalSetup = targetField.setup;
                const originalCommit = targetField.commit;

                targetField.setup = function (data) {
                    if (!data.target) {
                        data.target = {};
                    }

                    if ("undefined" === typeof data.type) {
                        // A brand new link which should default to target="_blank"
                        data.target.type = "_blank";
                        data.target.name = "_blank";
                    } else if (data.type === "anchor") {
                        // Force the target to be unset for anchor links
                        data.target.type = "notSet";
                        data.target.name = "notSet";
                    }

                    originalSetup.call(this, data);
                };

                targetField.commit = function (data) {
                    if (!data.target) {
                        data.target = {};
                    }

                    if (data.type === "anchor") {
                        // Force the target to be unset for anchor links
                        data.target.type = "notSet";
                        data.target.name = "notSet";
                    } else {
                        originalCommit.call(this, data);
                    }
                };
            } catch (e) {
                console.log("Couldn't update default link target", e);
            }
        });
    }
}

FieldEditor.register_editor("wysiwyg", FieldEditorWysiwyg);


FieldEditorWysiwyg.DEFAULT_TAGS = "a[!href,target]; h2 h3 h4 h5 p blockquote strong em ul ol li table thead tbody tr td th";

export default FieldEditorWysiwyg;
